// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import adminApi from "../services/admin/admin";
import adminSettingsApi from "../services/admin/settings";
import adminStudentsApi from "../services/admin/adminStudents";
import adminStudentAffiliationsApi from "../services/admin/adminStudentAffiliations";
import affiliationsApi from "../services/admin/affiliations";
import scholarshipsApi from "../services/admin/scholarships";
import adminUserSchoolApi from "../services/admin/adminUserSchool";
import adminAwardsApi from "../services/admin/adminAwards";
import adminAwardAssignApi from "../services/admin/adminAwardAssign";
import emailsApi from "../services/admin/emails";
import authApi from "../services/auth";
import applicationsApi from "../services/applications";
import settingsApi from "../services/settings";
import lookupsApi from "../services/lookups";
import genAppApi from "../services/gen-app";
import dasAppApi from "../services/das-app";
import statsApi from "../services/stats";
import studentsApi from "../services/students";
import scholarshipBooksApi from "../services/scholarship-book";
import publicAwardsApi from "../services/public-awards";
import awardTemplatesApi from "../services/admin/adminAwardTemplates";
import adminSettingTypesApi from "../services/admin/settingTypes";
import adminDiagnosticsApi from "../services/admin/diagnostics";
import awardDocumentsApi from "../services/admin/awardDocuments";
import { subjectAwardsApi } from "../services/admin/subject-awards";

const store = configureStore({
  reducer: {
    [adminApi.reducerPath]: adminApi.reducer,
    [adminSettingsApi.reducerPath]: adminSettingsApi.reducer,
    [adminStudentsApi.reducerPath]: adminStudentsApi.reducer,
    [adminStudentAffiliationsApi.reducerPath]:
      adminStudentAffiliationsApi.reducer,
    [affiliationsApi.reducerPath]: affiliationsApi.reducer,
    [scholarshipsApi.reducerPath]: scholarshipsApi.reducer,
    [adminUserSchoolApi.reducerPath]: adminUserSchoolApi.reducer,
    [adminAwardsApi.reducerPath]: adminAwardsApi.reducer,
    [adminAwardAssignApi.reducerPath]: adminAwardAssignApi.reducer,
    [emailsApi.reducerPath]: emailsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [lookupsApi.reducerPath]: lookupsApi.reducer,
    [applicationsApi.reducerPath]: applicationsApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [genAppApi.reducerPath]: genAppApi.reducer,
    [dasAppApi.reducerPath]: dasAppApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    [studentsApi.reducerPath]: studentsApi.reducer,
    [scholarshipBooksApi.reducerPath]: scholarshipBooksApi.reducer,
    [publicAwardsApi.reducerPath]: publicAwardsApi.reducer,
    [awardTemplatesApi.reducerPath]: awardTemplatesApi.reducer,
    [adminSettingTypesApi.reducerPath]: adminSettingTypesApi.reducer,
    [adminDiagnosticsApi.reducerPath]: adminDiagnosticsApi.reducer,
    [awardDocumentsApi.reducerPath]: awardDocumentsApi.reducer,
    [subjectAwardsApi.reducerPath]: subjectAwardsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(adminApi.middleware)
      .concat(adminSettingsApi.middleware)
      .concat(adminStudentsApi.middleware)
      .concat(adminStudentAffiliationsApi.middleware)
      .concat(affiliationsApi.middleware)
      .concat(scholarshipsApi.middleware)
      .concat(adminUserSchoolApi.middleware)
      .concat(adminAwardsApi.middleware)
      .concat(adminAwardAssignApi.middleware)
      .concat(emailsApi.middleware)
      .concat(authApi.middleware)
      .concat(lookupsApi.middleware)
      .concat(applicationsApi.middleware)
      .concat(settingsApi.middleware)
      .concat(genAppApi.middleware)
      .concat(dasAppApi.middleware)
      .concat(statsApi.middleware)
      .concat(studentsApi.middleware)
      .concat(scholarshipBooksApi.middleware)
      .concat(publicAwardsApi.middleware)
      .concat(awardTemplatesApi.middleware)
      .concat(adminSettingTypesApi.middleware)
      .concat(adminDiagnosticsApi.middleware)
      .concat(awardDocumentsApi.middleware)
      .concat(subjectAwardsApi.middleware),
});

setupListeners(store.dispatch);

export default store;
